/* VideoLinks collection filters.
   Phone/tablet (filter drawer): ticks are collected, a sticky bar shows "Clear all" + "Show N products";
   the page updates once, when the shopper taps the button. Closing the drawer without applying discards the ticks.
   Desktop (sidebar): filters still apply instantly; the scroll position inside long filter lists is kept.
   Uses the theme's own renderPage(), so results, URL and history work exactly as before.
   To undo: delete the <script> line for vl-filters-batch.js in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__vlFilters) return;
  window.__vlFilters = true;

  var css =
    '.vl-fbar{position:sticky;bottom:-16px;z-index:5;display:flex;align-items:center;gap:12px;margin:12px -18px -16px;padding:12px 18px calc(12px + env(safe-area-inset-bottom));background:rgba(255,255,255,.96);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);box-shadow:0 -1px 0 var(--vl-line,#E2E2DF),0 -12px 24px -18px rgba(20,20,20,.35)}' +
    '.vl-fbar__clear{flex:0 0 auto;padding:10px 4px;border:0;background:none;font:700 14px/1 var(--vl-body,inherit);color:var(--vl-ink-2,#3B3E44);text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.vl-fbar__clear[disabled]{opacity:.35;cursor:default}' +
    '.vl-fbar__apply{flex:1 1 auto;min-height:50px;border:0;border-radius:16px;background:linear-gradient(180deg,#1F66D1 0%,#054CB4 100%);color:#fff;font:800 15px/1 var(--vl-body,inherit);letter-spacing:.01em;cursor:pointer;box-shadow:inset 0 1px 0 rgba(255,255,255,.25),inset 0 -2px 0 rgba(0,0,0,.18),0 4px 10px -4px rgba(5,76,180,.55);transition:opacity .15s,filter .15s}' +
    '.vl-fbar__apply[disabled]{background:#E7E7E4;color:#878A90;box-shadow:none;cursor:default}' +
    '.vl-fbar__apply.is-busy{opacity:.75}' +
    'html body#m-theme .m-sidebar--open[data-vl-count]>svg{order:2}html body#m-theme .m-sidebar--open[data-vl-count]::after{order:1;content:attr(data-vl-count);display:inline-grid;place-items:center;min-width:20px;height:20px;margin-left:2px;padding:0 6px;border-radius:999px;background:var(--vl-blue,#054CB4);color:#fff;font:800 11.5px/1 var(--vl-body,inherit)}';
  var st = document.createElement('style'); st.id = 'vl-filters-batch-css'; st.textContent = css; document.head.appendChild(st);

  var form = function () { return document.getElementById('CollectionFiltersForm'); };
  var sidebar = function () { return document.querySelector('.m-sidebar'); };
  var isDrawer = function () { var s = sidebar(); return !!s && getComputedStyle(s).position === 'fixed'; };
  var isFilterInput = function (el) { return el && el.form === form() && el.name && el.name.indexOf('filter.') === 0; };
  var query = function () { var f = form(); return f ? new URLSearchParams(new FormData(f)).toString() : ''; };

  var applied = null, snapshot = null, countTimer = null, countSeq = 0;

  function takeSnapshot() {
    var f = form(); if (!f) return;
    applied = query();
    snapshot = [].map.call(f.querySelectorAll('input[name^="filter."]'), function (i) { return [i, i.checked, i.value]; });
  }
  function restoreSnapshot() {
    (snapshot || []).forEach(function (s) { if (s[0].type === 'checkbox' || s[0].type === 'radio') s[0].checked = s[1]; else s[0].value = s[2]; });
  }
  function activeCount() {
    var f = form(); if (!f) return 0;
    var n = f.querySelectorAll('input[type=checkbox][name^="filter."]:checked').length;
    var pr = [].filter.call(f.querySelectorAll('input[name^="filter.v.price"]'), function (i) { return i.value !== ''; }).length;
    return n + (pr ? 1 : 0);
  }
  function updateBadge() {
    var b = document.querySelector('.m-sidebar--open'); if (!b) return;
    var n = activeCount(); if (n) b.setAttribute('data-vl-count', n); else b.removeAttribute('data-vl-count');
  }

  function bar() {
    var c = document.querySelector('.m-sidebar--content'); if (!c) return null;
    var b = c.querySelector('.vl-fbar');
    if (!b) {
      b = document.createElement('div'); b.className = 'vl-fbar';
      b.innerHTML = '<button type="button" class="vl-fbar__clear">Clear all</button><button type="button" class="vl-fbar__apply" disabled>Show products</button>';
      c.appendChild(b);
      b.querySelector('.vl-fbar__clear').addEventListener('click', clearAll);
      b.querySelector('.vl-fbar__apply').addEventListener('click', apply);
    }
    return b;
  }
  function label(n) { return n === 1 ? 'Show 1 product' : 'Show ' + n + ' products'; }

  function refreshBar() {
    var b = bar(); if (!b) return;
    var btn = b.querySelector('.vl-fbar__apply'), clr = b.querySelector('.vl-fbar__clear');
    clr.disabled = activeCount() === 0;
    var q = query();
    if (q === applied) { btn.disabled = true; btn.classList.remove('is-busy'); btn.textContent = 'Show products'; return; }
    btn.disabled = false; btn.classList.add('is-busy'); btn.textContent = 'Updating…';
    clearTimeout(countTimer);
    var seq = ++countSeq;
    countTimer = setTimeout(function () {
      fetchCount(q).then(function (n) {
        if (seq !== countSeq) return;
        btn.classList.remove('is-busy');
        if (n === null) { btn.textContent = 'Show products'; btn.disabled = false; }
        else if (n === 0) { btn.textContent = 'No products match'; btn.disabled = true; }
        else { btn.textContent = label(n); btn.disabled = false; }
      });
    }, 300);
  }

  /* Count: render the theme's own results section for the pending filters (page 1, plus the last page when there are several). */
  function fetchCount(q) { return countFromSection(q); }
  function countFromSection(q) {
    var s = document.querySelector('.facest-filters-section'); if (!s) return Promise.resolve(null);
    var u = location.pathname + '?section_id=' + s.dataset.sectionId + '&' + q;
    var grab = function (url, warm) { return fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      // hand page 1 to the theme's own cache so "Show N products" renders instantly
      try { if (warm && typeof cachedFiltersResult !== 'undefined' && !cachedFiltersResult.some(function (c) { return c.url === url; })) cachedFiltersResult.push({ url: url, html: t }); } catch (e) {}
      return new DOMParser().parseFromString(t, 'text/html'); }); };
    return grab(u, true).then(function (d) {
      var g = d.querySelector('[data-product-container]'); if (!g) return 0;
      var per = g.querySelectorAll('.m-product-item').length, pages = Number(g.dataset.totalPages) || 1;
      if (pages <= 1) return per;
      return grab(u + '&page=' + pages).then(function (d2) {
        var g2 = d2.querySelector('[data-product-container]');
        return (pages - 1) * per + (g2 ? g2.querySelectorAll('.m-product-item').length : 0);
      });
    }).catch(function () { return null; });
  }

  function clearAll() {
    var f = form(); if (!f) return;
    f.querySelectorAll('input[type=checkbox][name^="filter."]').forEach(function (i) { i.checked = false; });
    f.querySelectorAll('input[name^="filter.v.price"]').forEach(function (i) { i.value = ''; });
    refreshBar();
  }
  function apply() {
    var el = document.querySelector('collection-filters-form'); var q = query();
    snapshot = null; applied = q;
    if (window.MinimogTheme && MinimogTheme.Collection && MinimogTheme.Collection.closeSidebarFilter) MinimogTheme.Collection.closeSidebarFilter();
    if (el && typeof el.renderPage === 'function') el.renderPage(q); else location.search = q;
  }

  // 1) In the drawer, stop the theme from reloading results on every tick.
  document.addEventListener('input', function (e) {
    if (!e.isTrusted || !isFilterInput(e.target)) return;
    if (isDrawer()) { e.stopImmediatePropagation(); refreshBar(); return; }
    rememberScroll();
  }, true);

  // 2) Opening the drawer: remember what is applied. Closing without applying: put the ticks back.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.m-sidebar--open')) { setTimeout(function () { takeSnapshot(); bar(); refreshBar(); }, 0); return; }
    var s = sidebar(); if (!s || !isDrawer() || !snapshot) return;
    if ((e.target.closest && e.target.closest('.m-sidebar--close')) || e.target === s) {
      if (query() !== applied) restoreSnapshot();
      snapshot = null;
    }
  }, true);

  // 3) Desktop: keep the scroll position inside long filter lists when results re-render.
  var tops = null;
  function rememberScroll() { tops = [].map.call(document.querySelectorAll('.m-facets'), function (l) { return l.scrollTop; }); }
  new MutationObserver(function (ms) {
    var replaced = ms.some(function (m) { return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.facest-filters-section') || (n.querySelector && n.querySelector('.facest-filters-section'))); }); });
    if (!replaced) return;
    updateBadge();
    if (tops) { var t = tops; tops = null; requestAnimationFrame(function () { document.querySelectorAll('.m-facets').forEach(function (l, i) { if (t[i]) l.scrollTop = t[i]; }); }); }
  }).observe(document.body, { childList: true, subtree: true });

  updateBadge();
})();
